import { render, staticRenderFns } from "./dlconHeader.vue?vue&type=template&id=61b8f0d5&scoped=true&"
import script from "./dlconHeader.vue?vue&type=script&lang=js&"
export * from "./dlconHeader.vue?vue&type=script&lang=js&"
import style0 from "./dlconHeader.vue?vue&type=style&index=0&id=61b8f0d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8f0d5",
  null
  
)

export default component.exports